// Composables/useWeather.js
import { ref } from "vue";
import { getWeather } from "@/Services/weatherService";

export function useWeather() {
    const clima = ref(null);
    const loading = ref(false);
    const error = ref(null);
    const city = ref("Parnaíba - PI");

    // Coordenadas fixas de Parnaíba - PI
    const PARNAIBA_COORDS = {
        latitude: -2.9056,
        longitude: -41.7734,
    };

    async function fetchWeather({ latitude, longitude }) {
        loading.value = true;
        error.value = null;

        try {
            const weatherData = await getWeather({
                latitude,
                longitude,
            });

            clima.value = weatherData;
        } catch (e) {
            error.value = e.message || "Erro ao buscar clima";
        } finally {
            loading.value = false;
        }
    }

    async function fetchByGeolocation() {
        await fetchWeather(PARNAIBA_COORDS);
    }

    return {
        clima,
        city,
        loading,
        error,
        fetchWeather,
        fetchByGeolocation,
    };
}
